/**
 * タイルタイプ
 */
export type TileType =
  | 'grass' // 草原（移動可）
  | 'forest' // 森（移動可）
  | 'water' // 水場（移動可、体力回復+10）
  | 'food_spot' // 食料スポット（現在は効果なし）
  | 'town' // 町（交流しやすい）
  | 'mountain' // 山（移動不可）
  // 属性ゾーン（デッキ突然変異発生）
  | 'fire_zone' // 炎の領域
  | 'water_zone' // 水の領域
  | 'light_zone' // 光の領域
  | 'dark_zone' // 闘の領域
  | 'primitive_zone' // 原始の領域
  | 'future_zone' // 未来の領域
  // 特殊ゾーン
  | 'forbidden_zone'; // 禁忌の地（禁忌カード獲得チャンス）

/**
 * 属性ゾーンタイプ一覧
 */
export const ATTRIBUTE_ZONE_TILES: TileType[] = [
  'fire_zone',
  'water_zone',
  'light_zone',
  'dark_zone',
  'primitive_zone',
  'future_zone',
];

/**
 * タイルから属性を取得
 */
export function getAttributeFromTile(tileType: TileType): string | null {
  switch (tileType) {
    case 'fire_zone':
      return '炎';
    case 'water_zone':
      return '水';
    case 'light_zone':
      return '光';
    case 'dark_zone':
      return '闇';
    case 'primitive_zone':
      return '原始';
    case 'future_zone':
      return '未来';
    default:
      return null;
  }
}

/**
 * 位置情報
 */
export interface Position {
  x: number;
  y: number;
}

/**
 * マップタイル
 */
export interface MapTile {
  x: number;
  y: number;
  type: TileType;
  npcs: string[]; // このマスにいるNPC ID配列
}

/**
 * ゲームマップ
 */
export interface GameMap {
  width: number;
  height: number;
  tiles: MapTile[][]; // tiles[y][x]
}

/**
 * マップ設定定数
 */
export const MAP_CONFIG = {
  WIDTH: 15, // 横15マス
  HEIGHT: 15, // 縦15マス
  TOTAL_TILES: 225, // 15x15
};
